// extracted by mini-css-extract-plugin
export default {"banner":"banner__qyNib","wrapper":"wrapper__fHMPf"};